import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing1, spacing2, spacing3 } from 'src/styles/spacing';

export const StyledContainer = styled.div`
  margin-bottom: ${spacing2};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing3};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const StyledLabel = styled(Typography)`
  padding-right: ${spacing1};
`;

export const StyledValue = styled(Typography)`
  font-weight: bold;
  margin-left: auto;
`;

export const StyledNoteRow = styled(StyledRow)`
  padding-top: ${spacing1};
`;
